import {
    ADMIN_DELETE_TRANSFER_TYPE_MAPPING_SUCCESS,
    ADMIN_DELETE_TRANSFER_TYPE_MAPPING_FAILED,
    LOADING_ADMIN_DELETE_TRANSFER_TYPE_MAPPING,
    NETWORK_ERROR_ADMIN_DELETE_TRANSFER_TYPE_MAPPING,
    RESET_ADMIN_DELETE_TRANSFER_TYPE_MAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminDeleteTransferTypeMapping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMIN_DELETE_TRANSFER_TYPE_MAPPING });
    await adminServices
        .post("deletetransfTypeMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: ADMIN_DELETE_TRANSFER_TYPE_MAPPING_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: ADMIN_DELETE_TRANSFER_TYPE_MAPPING_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMIN_DELETE_TRANSFER_TYPE_MAPPING,
                payload: err
            });
        });
};

export { adminDeleteTransferTypeMapping };
